/**
 * Keeps the specification table's SKU row in sync with the selected variant.
 *
 * A `product-rerender` wrapper cannot do this job. That component replaces itself with the
 * element of the same id found in `event.detail.htmlFragment`, and the fragment is a fetch of
 * `?section_id=<main product section>` alone (see `variant-picker`'s renderForCombination in
 * assets/theme.js). The tabs section is a different section, so it never appears in that
 * fragment: the lookup returns null and the component silently does nothing.
 *
 * The `variant:change` event carries the whole variant object, so the SKU can be updated
 * directly — no second request.
 */

if (!window.customElements.get('spec-variant-sku')) {
  window.customElements.define(
    'spec-variant-sku',
    class SpecVariantSku extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();

        // `variant:change` bubbles to the document, and quick-buy modals for complementary
        // products dispatch it too. Only the main product form of THIS product may drive
        // this cell — hence the prefix test in onVariantChange, which mirrors the id
        // captured in sections/main-product.liquid:66.
        document.addEventListener('variant:change', (event) => this.onVariantChange(event), {
          signal: this.abortController.signal,
        });
      }

      disconnectedCallback() {
        this.abortController.abort();
      }

      onVariantChange(event) {
        const expectedPrefix = `product-form-main-${this.getAttribute('product-id')}-`;

        if (!event.detail?.formId?.startsWith(expectedPrefix)) {
          return;
        }

        const sku = event.detail.variant?.sku;
        this.textContent = sku || '';

        // A variant without a SKU would otherwise leave a label beside an empty cell.
        const row = this.closest('tr');

        if (row) {
          row.hidden = !sku;
        }
      }
    }
  );
}
